export type ExperienceItem = {
  label: string;
  link: string;
};

export const experienceList: ExperienceItem[] = [
  {
    label: 'Angular',
    link: 'https://angular.jp/',
  },
  {
    label: 'RxJS',
    link: 'https://rxjs.dev/',
  },
  {
    label: 'NgRx',
    link: 'https://ngrx.io/',
  },
  {
    label: 'Ionic',
    link: 'https://ionicframework.jp/',
  },
  {
    label: 'React',
    link: 'https://ja.reactjs.org/',
  },
  {
    label: 'React Native',
    link: 'https://reactnative.dev/',
  },
  {
    label: 'Redux',
    link: 'https://redux.js.org/',
  },
  {
    label: 'Next.js',
    link: 'https://nextjs.org/',
  },
  {
    label: 'Gatsby',
    link: 'https://www.gatsbyjs.com/',
  },
  {
    label: 'Vue.js',
    link: 'https://www.gatsbyjs.com/',
  },
  {
    label: 'Jest',
    link: 'https://jestjs.io/ja/',
  },
  {
    label: 'Cypress',
    link: 'https://www.cypress.io/',
  },
  {
    label: 'VRT',
    link: 'https://www.google.com/search?q=%22visual+regression+test%22',
  },
  {
    label: 'TypeScript',
    link: 'https://www.typescriptlang.org/',
  },
  {
    label: 'Node.js',
    link: 'https://nodejs.org/ja/',
  },
  {
    label: 'NestJS',
    link: 'https://nextjs.org/',
  },
  {
    label: 'Swift',
    link: 'https://www.apple.com/jp/swift/',
  },
  {
    label: 'SwiftUI',
    link: 'https://developer.apple.com/jp/xcode/swiftui/',
  },
  {
    label: 'Kotlin',
    link: 'https://kotlinlang.org/',
  },
  {
    label: 'Jetpack Compose',
    link: 'https://developer.android.com/jetpack/compose?hl=ja',
  },
  {
    label: 'GraphQL',
    link: 'https://graphql.org/',
  },
  {
    label: 'Nx',
    link: 'https://nx.dev/',
  },
  {
    label: 'AWS Lambda',
    link: 'https://aws.amazon.com/jp/lambda/',
  },
  {
    label: 'AWS API Gateway',
    link: 'https://aws.amazon.com/jp/api-gateway/',
  },
  {
    label: 'AWS DynamoDB',
    link: 'https://aws.amazon.com/jp/dynamodb/',
  },
  {
    label: 'AWS CloudFront',
    link: 'https://aws.amazon.com/jp/cloudfront/',
  },
  {
    label: 'AWS S3',
    link: 'https://aws.amazon.com/jp/s3/',
  },
  {
    label: 'AWS Cognito',
    link: 'https://aws.amazon.com/jp/cognito/',
  },
  {
    label: 'Amplify',
    link: 'https://aws.amazon.com/jp/amplify/',
  },
  {
    label: 'Storybook',
    link: 'https://storybook.js.org/',
  },
  {
    label: 'UI Design',
    link: '',
  },
  {
    label: 'Cloudflare Worker',
    link: 'https://www.cloudflare.com/ja-jp/developer-platform/workers/',
  },
  {
    label: 'Supabase',
    link: 'https://supabase.com/',
  },
];
